import React from 'react';

const SharedMsg = () => {

    return (
        <section className="SharedMsg md-gray">
            Report results are limited to first 500 entries. Use the Bulk Download function to access additional reporting data.
        </section>
    );
};

export default SharedMsg;
